import React from 'react';
import { Feature } from 'flagged';
import { ReactComponent as Logo } from '../../images/logo.svg';
import styles from './styles.module.css';
import { LanguageSwitcherComponent } from '@pec/aion-ui-i18next/components/LanguageSwitcher';
import { FeatureFlagWrapper } from '@pec/aion-ui-core/features/featureFlags/components/FeatureFlagWrapper';
import { localizationFeatureFlag } from '@pec/aion-ui-i18next/constants';

const Header: React.FC = () => (
  <header className={styles.staticHeader}>
    <div className={styles.container}>
      <div className={styles.logoContainer}>
        <Logo data-testid="logo" />
      </div>
      <FeatureFlagWrapper>
        <Feature
          name={localizationFeatureFlag}
          render={(isEnabled: boolean) => isEnabled && <LanguageSwitcherComponent />}
        />
      </FeatureFlagWrapper>
    </div>
  </header>
);

export default Header;
